export class Message {
  id: number;
  title: string;
  summary: string;
  text: string;
  publishedAt: string;
}
